// Cart.js - Complete with blinking animation for NOT MET state
import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import CrackersLoader from "./CrackersLoader";
import { FaTrashAlt, FaShoppingCart, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCity, FaTag, FaWhatsapp } from "react-icons/fa";
import MobileNavigation from "./MobileNavigation";
import "./cart.css"

// Helper function to round to nearest whole number
const roundToNearestRupee = (amount) => {
  return Math.round(amount);
};

// Exact state names that qualify for local minimum order
const LOCAL_STATES = [
  "TAMIL NADU", "TAMILNADU", "TN",
  "PONDICHERRY", "PUDUCHERRY", "PY"
];

// Function to check if a state is local (Tamil Nadu or Pondicherry)
const isLocalState = (state) => {
  if (!state) return false;
  const normalizedState = state.toUpperCase().trim();
  for (const localState of LOCAL_STATES) {
    if (normalizedState === localState) return true;
  }
  if (normalizedState.includes("TAMIL NADU") || normalizedState === "TAMILNADU") return true;
  if (normalizedState.includes("PONDICHERRY") || normalizedState.includes("PUDUCHERRY") || normalizedState === "PY" || normalizedState === "PONDY") return true;
  return false;
};

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [discountvalue, setDiscountvalue] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [minimumOrder, setMinimumOrder] = useState(3000);
  const [otherStateMinimumOrder, setOtherStateMinimumOrder] = useState(1000);
  const [storeClosed, setStoreClosed] = useState(null);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 426);

  const getMinimumOrderForState = () => {
    const selectedState = (formData.state || "").trim();
    if (isLocalState(selectedState)) {
      return minimumOrder;
    } else {
      return otherStateMinimumOrder;
    }
  };

  const isMinimumOrderMet = () => {
    if (!formData.state) return false;
    const minRequired = getMinimumOrderForState();
    return grandTotal() >= minRequired;
  };

  const getAmountNeeded = () => {
    const minRequired = getMinimumOrderForState();
    const needed = minRequired - grandTotal();
    return needed > 0 ? needed : 0;
  };

  const getStateCategory = () => {
    const selectedState = (formData.state || "").trim();
    if (isLocalState(selectedState)) {
      if (selectedState.toUpperCase().includes("TAMIL")) return "Tamil Nadu";
      if (selectedState.toUpperCase().includes("POND") || selectedState.toUpperCase().includes("PUDU")) return "Pondicherry / Puducherry";
      return "Local Region (TN/PY)";
    } else if (selectedState) {
      return "Other State";
    }
    return "";
  };

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 426);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
  }, []);

  const handleQuantityChange = (product_id, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.product_id === product_id) {
        const newCount = item.count + change;
        if (newCount < 1) return { ...item, count: 1 };
        if (newCount > item.stock) {
          alert(`Only ${item.stock} item(s) available in stock.`);
          return item;
        }
        return { ...item, count: newCount };
      }
      return item;
    });
    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    const updatedCounts = updatedItems.reduce((acc, item) => {
      acc[item.product_id] = item.count;
      return acc;
    }, {});
    saveCountsToLocalStorage(updatedCounts);
  };

  const handleDelete = (product_id) => {
    const updatedItems = cartItems.filter(item => item.product_id !== product_id);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    setCartItems(updatedItems);
    localStorage.removeItem(`count_${product_id}`);
    const totalUniqueProductCount = updatedItems.length;
    localStorage.setItem("cartCount", totalUniqueProductCount);
    saveCountsToLocalStorage(updatedItems);
  };

  const calculateTotal = (price, count) => {
    if (!price) return "0";
    const sanitizedPrice = parseFloat(price.replace(/[^\d.-]/g, ""));
    if (isNaN(sanitizedPrice)) return "0";
    return roundToNearestRupee(count * sanitizedPrice);
  };

  const getSubtotal = () => {
    return roundToNearestRupee(
      cartItems.reduce((total, item) => total + parseFloat(calculateTotal(item.oldprice, item.count)), 0)
    );
  };

  const getDiscountedTotal = () => {
    const discountAmount = cartItems.reduce((total, item) => {
      if (item.is_non_discount === "0") {
        const discount = Math.round(discountvalue);
        const itemTotal = parseFloat(calculateTotal(item.oldprice, item.count));
        const discountedItemTotal = (itemTotal * discount) / 100;
        return total + discountedItemTotal;
      }
      return total;
    }, 0);
    return roundToNearestRupee(discountAmount);
  };

  const getOrderTotal = () => {
    const subtotal = getSubtotal();
    const discountTotal = getDiscountedTotal();
    return roundToNearestRupee(subtotal - discountTotal);
  };

  const grandTotal = () => {
    let total = getOrderTotal();
    return roundToNearestRupee(total);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber" && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: null });
    }
  };

  const validateForm = () => {
    const errors = {};
    const requiredFields = ["firstName", "mobileNumber", "address", "city", "state", "pincode"];
    requiredFields.forEach((key) => {
      if (!formData[key]) errors[key] = "This field is required.";
    });
    if (formData.mobileNumber && formData.mobileNumber.length !== 10) {
      errors.mobileNumber = "Mobile number must be 10 digits.";
    }
    if (formData.pincode && !/^\d{6}$/.test(formData.pincode)) {
      errors.pincode = "Pincode must be 6 digits.";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOrderSuccess = (orderId) => {
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartCount");
    const productKeys = Object.keys(localStorage).filter(key => key.startsWith("count_"));
    productKeys.forEach(key => localStorage.removeItem(key));
    window.dispatchEvent(new Event("cartUpdated"));
    if (orderId) {
      navigate(`/thanks?order_id=${orderId}`);
    } else {
      navigate("/thanks");
    }
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const loadAllData = async () => {
      try {
        const homeRes = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = homeRes.data;
        if (body) {
          const storeInfo = body.minimum_order_store_closed?.[0];
          if (storeInfo) {
            setMinimumOrder(storeInfo.minimum_order || 3000);
            setOtherStateMinimumOrder(storeInfo.other_state_minimum_order || 1000);
            setStoreClosed(storeInfo.store_closed);
          }
          setDiscountvalue(body.discount_value?.[0]?.discount_value || 0);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadAllData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (!isMinimumOrderMet()) {
        const minRequired = getMinimumOrderForState();
        const needed = getAmountNeeded();
        alert(`Minimum order amount for ${formData.state} is ₹${minRequired}. Please add ₹${needed} more to proceed.`);
        return;
      }
      setLoading(true);
      const orderData = {
        name: formData.firstName,
        email: formData.email,
        phonenumber: formData.mobileNumber,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        subtotal: getSubtotal(),
        discount: getDiscountedTotal(),
        discount_percentage: Math.round(discountvalue),
        totalsgst_amt: 0,
        totalcgst_amt: 0,
        coupon_discount: 0,
        total: grandTotal(),
        coupen_code: "",
        product: cartItems.map((item) => {
          const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;
          const price = isNonDiscount ? item.oldprice : item.price;
          const sanitizedPrice = parseFloat(price.replace(/[^\d.-]/g, ""));
          return {
            product_id: item.product_id,
            category_id: item.category_id || "",
            product_name: item.product_name,
            unit_price: sanitizedPrice,
            quantity: item.count,
            final_price: calculateTotal(price, item.count),
            discount: isNonDiscount ? 0 : Math.round(discountvalue)
          };
        }),
      };
      try {
        const response = await axios.post(`${API_BASE_URL}order.php`, orderData);
        if (response.data?.head?.code === 200) {
          alert("Order placed successfully!");
          const orderId = response.data?.body?.order_id;
          handleOrderSuccess(orderId);
        } else {
          alert("Failed to place order: " + (response.data?.head?.msg || "Unknown error"));
        }
      } catch (error) {
        console.error("There was an error placing the order!", error);
        alert("Failed to place order. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const saveCountsToLocalStorage = (data) => {
    if (Array.isArray(data)) {
      data.forEach((item) => localStorage.setItem(`count_${item.product_id}`, item.count));
    } else {
      Object.entries(data).forEach(([product_id, count]) => localStorage.setItem(`count_${product_id}`, count));
    }
    window.dispatchEvent(new Event("storage"));
  };

  if (isLoading) return <CrackersLoader />;

  const minRequiredForCurrentState = formData.state ? getMinimumOrderForState() : null;
  const isMinMet = formData.state ? isMinimumOrderMet() : false;
  const amountNeeded = formData.state ? getAmountNeeded() : 0;
  const stateCategory = formData.state ? getStateCategory() : "";

  return (
    <div className="mathi-cart-page">
      <Header />

      {/* Cart Header */}
      <div className="cart-header-section">
        <div className="cart-content-wrapper">
          <div className="cart-header-content text-center py-4">
            <FaShoppingCart className="cart-header-icon" />
            <h1 className="cart-title">Your Shopping Cart</h1>
            <p className="cart-subtitle">Review your items and proceed to checkout</p>
            <div className="cart-items-count">
              <span className="badge bg-primary">{cartItems.length} items</span>
            </div>
          </div>
        </div>
      </div>

      <div className="cart-content-wrapper">
        {/* Cart Items Table */}
        <div className="cart-table-section mb-4">
          <div className="table-responsive">
            <Table className="mathi-cart-table">
              <thead>
                <tr className="cart-table-header">
                  <th className="text-center">Image</th>
                  <th className="text-center">Product Name</th>
                  {!isSmallScreen && <th className="text-center">Price</th>}
                  {!isSmallScreen && <th className="text-center">Quantity</th>}
                  <th className="text-center">Total</th>
                  <th className="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length === 0 ? (
                  <tr>
                    <td colSpan={isSmallScreen ? 4 : 6} className="text-center py-5">
                      <div className="empty-cart">
                        <FaShoppingCart className="empty-cart-icon" />
                        <h5>Your cart is empty</h5>
                        <p>Add some crackers to get started!</p>
                        <Link to="/" className="btn btn-primary">Continue Shopping</Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  cartItems.map((item) => {
                    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;
                    const roundedOldPrice = item.oldprice ? roundToNearestRupee(parseFloat(item.oldprice.replace(/[^\d.-]/g, ""))) : 0;
                    const roundedPrice = item.price ? roundToNearestRupee(parseFloat(item.price.replace(/[^\d.-]/g, ""))) : 0;
                    return (
                      <tr key={item.product_id} className="cart-item-row">
                        <td className="cart-item-image">
                          <img src={item.image} alt={item.product_name} loading="lazy" className="img-thumbnail" />
                        </td>
                        <td className="cart-item-details">
                          <h6 className="cart-item-name">{item.product_name}</h6>
                          {isSmallScreen && (
                            <div className="mobile-price-qty">
                              <div className="mobile-price">
                                {isNonDiscount ? (
                                  <span className="current-price">₹ {roundedOldPrice}</span>
                                ) : (
                                  <>
                                    <del className="old-price">₹ {roundedOldPrice}</del>
                                    <span className="current-price">₹ {roundedPrice}</span>
                                  </>
                                )}
                              </div>
                              <div className="mobile-quantity">
                                <Button variant="outline-secondary" size="sm" onClick={() => handleQuantityChange(item.product_id, -1)}>-</Button>
                                <span className="quantity-display">{item.count}</span>
                                <Button variant="outline-secondary" size="sm" onClick={() => handleQuantityChange(item.product_id, 1)}>+</Button>
                              </div>
                            </div>
                          )}
                        </td>
                        {!isSmallScreen && (
                          <td className="cart-item-price text-center">
                            {isNonDiscount ? (
                              <span className="current-price">₹ {roundedOldPrice}</span>
                            ) : (
                              <>
                                <del className="old-price">₹ {roundedOldPrice}</del>
                                <br />
                                <span className="current-price">₹ {roundedPrice}</span>
                              </>
                            )}
                          </td>
                        )}
                        {!isSmallScreen && (
                          <td className="cart-item-quantity">
                            <div className="quantity-control">
                              <Button variant="outline-secondary" size="sm" onClick={() => handleQuantityChange(item.product_id, -1)}>-</Button>
                              <span className="quantity-number">{item.count}</span>
                              <Button variant="outline-secondary" size="sm" onClick={() => handleQuantityChange(item.product_id, 1)}>+</Button>
                            </div>
                          </td>
                        )}
                        <td className="cart-item-total text-center">
                          <span className="item-total">
                            ₹ {calculateTotal(isNonDiscount ? item.oldprice : item.price, item.count)}
                          </span>
                        </td>
                        <td className="cart-item-action text-center">
                          <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item.product_id)} title="Remove item" className="delete-button">
                            <FaTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Cart Summary and Checkout */}
        <div className="row">
          <div className="col-lg-8">
            <Card className="cart-form-card shadow-sm">
              <Card.Body>
                <div className="form-header mb-4">
                  <div className="form-icon"><FaUser /></div>
                  <h4>Customer Details</h4>
                  <p className="text-muted">Fill in your information to proceed</p>
                </div>
                <Form noValidate onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label"><FaUser className="me-2" /> Full Name *</label>
                        <Form.Control type="text" name="firstName" placeholder="Enter your full name" value={formData.firstName} onChange={handleChange} isInvalid={!!formErrors.firstName} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.firstName}</Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label"><FaPhone className="me-2" /> Mobile Number *</label>
                        <Form.Control type="tel" name="mobileNumber" placeholder="Enter 10-digit mobile number" value={formData.mobileNumber} onChange={handleChange} isInvalid={!!formErrors.mobileNumber} maxLength={10} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.mobileNumber}</Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label"><FaEnvelope className="me-2" /> Email Address</label>
                        <Form.Control type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} isInvalid={!!formErrors.email} className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.email}</Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label"><FaCity className="me-2" /> City *</label>
                        <Form.Control type="text" name="city" placeholder="Enter your city" value={formData.city} onChange={handleChange} isInvalid={!!formErrors.city} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.city}</Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label"><FaMapMarkerAlt className="me-2" /> State *</label>
                        <Form.Control type="text" name="state" placeholder="Enter your state (e.g., Tamil Nadu, Pondicherry)" value={formData.state} onChange={handleChange} isInvalid={!!formErrors.state} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.state}</Form.Control.Feedback>
                        <small className="text-muted">Tamil Nadu / Pondicherry have ₹{minimumOrder} minimum order</small>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">Pincode *</label>
                        <Form.Control type="text" name="pincode" placeholder="Enter 6-digit pincode" value={formData.pincode} onChange={(e) => { const value = e.target.value; if (/^\d{0,6}$/.test(value)) handleChange(e); }} maxLength={6} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.pincode}</Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="form-group">
                        <label className="form-label"><FaMapMarkerAlt className="me-2" /> Complete Address *</label>
                        <Form.Control as="textarea" name="address" placeholder="Enter your complete address" rows={3} value={formData.address} onChange={handleChange} isInvalid={!!formErrors.address} required className="form-control-lg" />
                        <Form.Control.Feedback type="invalid">{formErrors.address}</Form.Control.Feedback>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="cart-summary-card shadow-sm">
              <Card.Body>
                <div className="summary-header mb-4">
                  <h4>Order Summary</h4>
                  <p className="text-muted">Review your order details</p>
                </div>

                {/* Order Summary */}
                <div className="order-summary mb-4">
                  <h6 className="summary-title">Price Details</h6>
                  <div className="summary-items">
                    <div className="summary-item d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span className="fw-bold">₹ {getSubtotal()}</span>
                    </div>
                    <div className="summary-item d-flex justify-content-between">
                      <span>Discount ({Math.round(discountvalue)}%)</span>
                      <span className="text-success">- ₹ {getDiscountedTotal()}</span>
                    </div>
                    <div className="summary-total d-flex justify-content-between mt-3 pt-3 border-top">
                      <span className="fw-bold">Total Amount</span>
                      <span className="fw-bold fs-5 text-primary">₹ {grandTotal()}</span>
                    </div>
                  </div>
                </div>

                {/* Minimum Order Display - RED BOX BLINKS WHEN NOT MET */}
                <div className="minimum-order-card mb-4">
                  <div className="card border-0 rounded-4 p-3" style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
                  }}>
                    <div className="d-flex align-items-center mb-3">
                      <div className="me-2" style={{
                        background: 'rgba(255,255,255,0.2)',
                        borderRadius: '50%',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <span style={{ fontSize: '1.2rem' }}>📍</span>
                      </div>
                      <h6 className="mb-0 fw-bold" style={{ letterSpacing: '0.5px' }}>Minimum Order Requirements</h6>
                    </div>

                    {/* Tamil Nadu & Pondicherry - Row 1 */}
                    <div className="mb-2 p-2 rounded-3" style={{
                      background: 'rgba(255,255,255,0.15)',
                      backdropFilter: 'blur(10px)'
                    }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>📍 Tamil Nadu & Pondicherry</span>
                        </div>
                        <strong className="fs-5">₹ {minimumOrder?.toLocaleString()}</strong>
                      </div>
                    </div>

                    {/* Other States - Row 2 */}
                    <div className="mb-3 p-2 rounded-3" style={{
                      background: 'rgba(255,255,255,0.15)',
                      backdropFilter: 'blur(10px)'
                    }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>🚚 Other States</span>
                        </div>
                        <strong className="fs-5">₹ {otherStateMinimumOrder?.toLocaleString()}</strong>
                      </div>
                    </div>

                    <hr className="my-2" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />

                    {formData.state && (
                      // THIS IS THE BOX THAT BLINKS WHEN REQUIREMENT IS NOT MET
                      <div className={`mt-2 p-3 rounded-3 ${!isMinMet ? 'minimum-not-met-box warning-blink' : 'minimum-met'}`}>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <div>
                            <span className="fw-bold">{formData.state}</span>
                            <span className="ms-2 small" style={{ opacity: 0.9 }}>({stateCategory})</span>
                          </div>
                          <div className="mt-1 mt-sm-0">
                            Required: <strong className="fs-5 ms-1">₹ {minRequiredForCurrentState?.toLocaleString()}</strong>
                          </div>
                        </div>
                        {!isMinMet ? (
                          <div className="mt-2 d-flex align-items-center">
                            <span className="me-2 blink-icon">⚠️</span>
                            <span className="small fw-medium blink-text">Need ₹ {amountNeeded} more to reach minimum order</span>
                            <div className="ms-auto">
                              <div className="progress" style={{
                                width: '80px',
                                height: '6px',
                                background: 'rgba(255,255,255,0.3)',
                                borderRadius: '10px'
                              }}>
                                <div className="progress-bar bg-white" role="progressbar"
                                  style={{
                                    width: `${Math.min(100, (grandTotal() / minRequiredForCurrentState) * 100)}%`,
                                    borderRadius: '10px'
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mt-2 d-flex align-items-center">
                            <span className="me-2">✅</span>
                            <span className="small fw-medium">Minimum order requirement met! Ready to checkout 🎉</span>
                          </div>
                        )}
                      </div>
                    )}

                    {!formData.state && (
                      <div className="mt-2 text-center p-2 rounded-3" style={{
                        background: 'rgba(255,255,255,0.1)'
                      }}>
                        <small>Enter your state above to see minimum order requirements</small>
                      </div>
                    )}
                  </div>
                </div>

                {storeClosed === "1" ? (
                  <div className="alert alert-danger" role="alert">
                    <h6>Store Closed</h6>
                    <p className="mb-0">Our store is currently closed. Please try again later.</p>
                  </div>
                ) : (
                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100 mb-3"
                    onClick={handleSubmit}
                    disabled={loading || cartItems.length === 0 || (formData.state && !isMinMet)}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Processing...
                      </>
                    ) : (
                      <>
                        <FaWhatsapp className="me-2" />
                        Submit Your Enquiry
                      </>
                    )}
                  </Button>
                )}

                {/* Cart Info */}
                <div className="cart-info mt-4">
                  <div className="info-item d-flex align-items-center mb-2">
                    <div className="info-icon me-2"><FaShoppingCart /></div>
                    <div className="info-text"><small className="text-muted">{cartItems.length} item(s) in cart</small></div>
                  </div>
                  <div className="info-item d-flex align-items-center">
                    <div className="info-icon me-2"><FaTag /></div>
                    <div className="info-text"><small className="text-muted">{Math.round(discountvalue)}% discount applied on eligible items</small></div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      <MobileNavigation />
      <Scroll />
    </div>
  );
}

export default Cart;